module.exports = __webpack_public_path__ + "img/seminar1.abc27fc4.jpg";